window.addEventListener('DOMContentLoaded', (event) => {
    jQuery('.tabanimationcontainer').animate({
        height: (jQuery('.tabscontainer').height() + 20) + 'px'
    }, 100);
});





jQuery('.taboption').click(function(event) {
var tabid = jQuery(event.target).attr('id')

if (jQuery(event.target).hasClass('activetab')) {
    console.log("has activetab..");

} else {
    jQuery('.activetab').removeClass('activetab');
    jQuery(event.target).addClass('activetab');
    jQuery('.tabanimationcontainer').animate({
        left: '-50px'
    }, 200);
    jQuery('.tabcontainer').animate({
        opacity: '0'
    }, 200, function() {
        jQuery('.tabcontainer').hide();
        jQuery('.' + tabid).show();
        console.log("show: " + '.' + tabid + "  object: " + jQuery('.' + tabid))


    });
    // jQuery('.tabcontainer').hide();
    setTimeout(function() {
        jQuery('.tabanimationcontainer').animate({
            left: '50px'
        }, 0);
        jQuery('.' + tabid).animate({
            opacity: '1'
        }, 200);
        jQuery('.tabanimationcontainer').animate({
            left: '0px'
        }, 200);
    }, 200);
    


    setTimeout(function() {

        jQuery('.tabanimationcontainer').animate({
            height: (jQuery('.tabscontainer').height() + 20) + 'px'
        }, 400);
    }, 300);


}
});

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

if (getUrlParameter('ind') !== null) {
// Get the value of the "ind" parameter
var indValue = parseInt(getUrlParameter('ind'));

// Output the value (for demonstration purposes)
//console.log('Value of "ind" parameter:', indValue, ' #tab_' + indValue);

jQuery('#tab_' + indValue).trigger('click');
}